import { Toaster as HotToaster } from 'react-hot-toast';
import { Icons } from '@/utils/icons';

export function Toaster() {
  return (
    <HotToaster
      position="top-center"
      containerStyle={{ zIndex: 10000 }}
      toastOptions={{
        duration: 4000,
        style: {
          borderRadius: '5px',
          border: 0,
          fontSize: '16px',
          fontWeight: 400,
          padding: '10px 12px',
          background: 'hsl(var(--card))',
          color: 'hsl(var(--card-foreground))',
        },
        loading: {
          duration: Infinity,
          icon: <Icons.loading className="h-5 w-5 shrink-0 animate-spin" />,
        },
      }}
    />
  );
}
